// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@keyframes upDown {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0);
  }
}
.checker_main {
  min-height: 74vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  color: #4d4d4d;
}
.checker_main .site_select {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.checker_main .site_select select {
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
}
.checker_main .invoice_header {
  background-color: #fff;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
  border-radius: 1rem;
  width: 70vw;
  margin: 1% auto;
  position: relative;
}
.checker_main .invoice_header .header {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.checker_main .invoice_header .header h2 span {
  color: #2c53a0;
}
.checker_main .invoice_header .icon {
  position: absolute;
  bottom: 2%;
  right: 2%;
  animation: upDown 1.5s infinite;
  -webkit-animation: upDown 1.5s infinite;
}
.checker_main .invoice_header .invoice {
  width: 95%;
  margin: 1% auto;
}
.checker_main .invoice_header .invoice table {
  width: 100%;
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
}
.checker_main .invoice_header .invoice table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.checker_main .invoice_header .invoice table tbody {
  text-align: center;
}
.checker_main .invoice_header .invoice table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.checker_main .invoice_header .invoice table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.checker_main .invoice_header .invoice table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}

.dispos_main {
  min-height: 74vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  color: #4d4d4d;
  overflow: auto;
}
.dispos_main table {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  width: 50%;
  margin: 2% auto;
}
.dispos_main table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.dispos_main table tbody {
  text-align: center;
}
.dispos_main table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.dispos_main table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.dispos_main table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
.dispos_main table td {
  padding: 3%;
}
@media (max-width: 600px) {
  .dispos_main table {
    width: 85vw;
    word-wrap: break-word;
    margin-left: -7.5vw;
    font-size: 0.9rem;
  }
}
.dispos_main button {
  background-color: #0095ff;
  border: 1px solid transparent;
  border-radius: 3px;
  box-shadow: rgba(255, 255, 255, 0.4) 0 1px 0 0 inset;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: -apple-system, system-ui, "Segoe UI", "Liberation Sans", sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.15385;
  margin: 0;
  outline: none;
  padding: 8px 0.8em;
  position: relative;
  text-align: center;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: baseline;
  white-space: nowrap;
}
.dispos_main button:hover, .dispos_main button:focus {
  background-color: #07c;
}
.dispos_main button:focus {
  box-shadow: 0 0 0 4px rgba(0, 149, 255, 0.15);
}
.dispos_main button:active {
  background-color: #0064bd;
  box-shadow: none;
}
.dispos_main .loader_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.dispos_main .loader_container .loader_circles {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5% auto;
  --color: hsl(0, 1%, 42%);
  --animation: 2s ease-in-out infinite;
}
.dispos_main .loader_container .loader_circles .circle {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 20px;
  height: 20px;
  border: solid 2px var(--color);
  border-radius: 50%;
  margin: 0 10px;
  background-color: transparent;
  animation: circle-keys var(--animation);
}
.dispos_main .loader_container .loader_circles .circle .dot {
  position: absolute;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: var(--color);
  animation: dot-keys var(--animation);
}
.dispos_main .loader_container .loader_circles .circle .outline {
  position: absolute;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  animation: outline-keys var(--animation);
}
.dispos_main .loader_container .loader_circles .circle:nth-child(1) .outline {
  animation-delay: 0.9s;
}
.dispos_main .loader_container .loader_circles .circle:nth-child(2) {
  animation-delay: 0.3s;
}
.dispos_main .loader_container .loader_circles .circle:nth-child(2) .dot {
  animation-delay: 0.3s;
}
.dispos_main .loader_container .loader_circles .circle:nth-child(2) .outline {
  animation-delay: 1.2s;
}
.dispos_main .loader_container .loader_circles .circle:nth-child(3) {
  animation-delay: 0.6s;
}
.dispos_main .loader_container .loader_circles .circle:nth-child(3) .dot {
  animation-delay: 0.6s;
}
.dispos_main .loader_container .loader_circles .circle:nth-child(3) .outline {
  animation-delay: 1.5s;
}
.dispos_main .loader_container .loader_circles .circle:nth-child(4) {
  animation-delay: 0.9s;
}
.dispos_main .loader_container .loader_circles .circle:nth-child(4) .dot {
  animation-delay: 0.9s;
}
.dispos_main .loader_container .loader_circles .circle:nth-child(4) .outline {
  animation-delay: 1.8s;
}
.dispos_main .loader_container .loader_circles .circle:nth-child(5) {
  animation-delay: 1.2s;
}
.dispos_main .loader_container .loader_circles .circle:nth-child(5) .dot {
  animation-delay: 1.2s;
}
.dispos_main .loader_container .loader_circles .circle:nth-child(5) .outline {
  animation-delay: 2.1s;
}

@keyframes circle-keys {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes dot-keys {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes outline-keys {
  0% {
    transform: scale(0);
    outline: solid 20px var(--color);
    outline-offset: 0;
    opacity: 1;
  }
  100% {
    transform: scale(1);
    outline: solid 0 transparent;
    outline-offset: 20px;
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/warehouse/invoice/invoiceCheck.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;EACE;IACE,wBAAA;EAIF;EADA;IACE,2BAAA;EAGF;EAAA;IACE,wBAAA;EAEF;AACF;AACA;EACE,gBAAA;EDmDE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ECpDF,cDhBU;ACoBZ;AAFE;ED4GE,aAAA;EACA,mBAAA;EACA,2BAAA;ACvGJ;AAJI;EACE,yBAAA;EACA,qBAAA;AAMN;AAFE;EDEE,sBAAA;EAJA,0CAAA;EAMA,mBAAA;ECFA,WAAA;EACA,eAAA;EACA,kBAAA;AAMJ;AAJI;EDoDA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AC7CJ;AANQ;EACE,cDzCE;ACiDZ;AAHI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,+BAAA;EACA,uCAAA;AAKN;AAFI;EACE,UAAA;EACA,eAAA;AAIN;AAFM;EACE,WAAA;ED4EJ,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;ACgEZ;ADwEI;EACI,gCAAA;EACA,kBAAA;ACtER;ADwEI;EACI,kBAAA;ACtER;ADuEQ;EACI,gCAAA;ACrEZ;ADsEY;EACI,yBAAA;ACpEhB;ADsEY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;ACpEhB;;AAnBA;EACE,gBAAA;EACA,YAAA;EDAE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ECDF,cDnEU;ECqEV,cAAA;AAwBF;AAtBE;ED6DE,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;ECyER,UAAA;EACA,eAAA;AA2BJ;ADmCI;EACI,gCAAA;EACA,kBAAA;ACjCR;ADmCI;EACI,kBAAA;ACjCR;ADkCQ;EACI,gCAAA;AChCZ;ADiCY;EACI,yBAAA;AC/BhB;ADiCY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;AC/BhB;AA5CK;EACC,WAAA;AA8CN;AA5CI;EAPF;IAQI,WAAA;IACA,qBAAA;IACA,mBAAA;IACA,iBAAA;EA+CJ;AACF;AA5CE;EACE,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,oDAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,gFAAA;EAEA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,0BAAA;EACA,wBAAA;EACA,mBAAA;AA6CJ;AA3CI;EAEE,sBAAA;AA4CN;AAzCI;EACE,6CAAA;AA2CN;AAxCI;EACE,yBAAA;EACA,gBAAA;AA0CN;AAtCE;ED9DE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ACuGJ;AAzCI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,wBAAA;EACA,oCAAA;AA2CN;AAzCM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,uCAAA;AA2CR;AAzCQ;EACE,kBAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,oCAAA;AA2CV;AAxCQ;EACE,kBAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;AA0CV;AAtCU;EACE,qBAAA;AAwCZ;AApCQ;EACE,qBAAA;AAsCV;AApCU;EACE,qBAAA;AAsCZ;AAnCU;EACE,qBAAA;AAqCZ;AAjCQ;EACE,qBAAA;AAmCV;AAjCU;EACE,qBAAA;AAmCZ;AAhCU;EACE,qBAAA;AAkCZ;AA9BQ;EACE,qBAAA;AAgCV;AA9BU;EACE,qBAAA;AAgCZ;AA7BU;EACE,qBAAA;AA+BZ;AA3BQ;EACE,qBAAA;AA6BV;AA3BU;EACE,qBAAA;AA6BZ;AA1BU;EACE,qBAAA;AA4BZ;;AApBA;EACE;IACE,mBAAA;IACA,UAAA;EAuBF;EApBA;IACE,qBAAA;IACA,YAAA;EAsBF;EAnBA;IACE,mBAAA;IACA,UAAA;EAqBF;AACF;AAlBA;EACE;IACE,mBAAA;EAoBF;EAjBA;IACE,mBAAA;EAmBF;EAhBA;IACE,mBAAA;EAkBF;AACF;AAfA;EACE;IACE,mBAAA;IACA,gCAAA;IACA,iBAAA;IACA,UAAA;EAiBF;EAdA;IACE,mBAAA;IACA,4BAAA;IACA,oBAAA;IACA,UAAA;EAgBF;AACF","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import '../../variables.scss';\n\n@keyframes upDown {\n  0% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-5px);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n\n.checker_main {\n  min-height: 74vh;\n  @include columnStart;\n  color: $fontColor;\n\n  .site_select {\n    @include rowStart;\n\n    select {\n      border: 1px solid $nitroDark;\n      border-radius: 0.5rem;\n    }\n  }\n\n  .invoice_header {\n    @include card;\n    width: 70vw;\n    margin: 1% auto;\n    position: relative;\n\n    .header {\n      @include rowEven;\n\n      h2 {\n        span {\n          color: $nitroDark;\n        }\n      }\n    }\n\n    .icon {\n      position: absolute;\n      bottom: 2%;\n      right: 2%;\n      animation: upDown 1.5s infinite;\n      -webkit-animation: upDown 1.5s infinite;\n    }\n\n    .invoice {\n      width: 95%;\n      margin: 1% auto;\n\n      table {\n        width: 100%;\n        @include table;\n      }\n    }\n  }\n}\n\n.dispos_main {\n  min-height: 74vh;\n  height: 100%;\n  @include columnStart;\n  color: $fontColor;\n  // flex:1;\n  overflow:auto;\n\n  table {\n    @include table;\n    width: 50%;\n    margin: 2% auto;\n     td{\n      padding:3%;\n    }\n    @media(max-width: $mobile){\n      width: 85vw;\n      word-wrap: break-word;\n      margin-left: -7.5vw;\n      font-size: .9rem;\n  }\n  }\n\n  button {\n    background-color: #0095ff;\n    border: 1px solid transparent;\n    border-radius: 3px;\n    box-shadow: rgba(255, 255, 255, 0.4) 0 1px 0 0 inset;\n    box-sizing: border-box;\n    color: #fff;\n    cursor: pointer;\n    display: inline-block;\n    font-family: -apple-system, system-ui, \"Segoe UI\", \"Liberation Sans\",\n      sans-serif;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.15385;\n    margin: 0;\n    outline: none;\n    padding: 8px 0.8em;\n    position: relative;\n    text-align: center;\n    text-decoration: none;\n    user-select: none;\n    -webkit-user-select: none;\n    touch-action: manipulation;\n    vertical-align: baseline;\n    white-space: nowrap;\n\n    &:hover,\n    &:focus {\n      background-color: #07c;\n    }\n\n    &:focus {\n      box-shadow: 0 0 0 4px rgba(0, 149, 255, 0.15);\n    }\n\n    &:active {\n      background-color: #0064bd;\n      box-shadow: none;\n    }\n  }\n\n  .loader_container {\n    @include columnStart;\n\n    .loader_circles {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin: 5% auto;\n      --color: hsl(0, 1%, 42%);\n      --animation: 2s ease-in-out infinite;\n\n      .circle {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        position: relative;\n        width: 20px;\n        height: 20px;\n        border: solid 2px var(--color);\n        border-radius: 50%;\n        margin: 0 10px;\n        background-color: transparent;\n        animation: circle-keys var(--animation);\n\n        .dot {\n          position: absolute;\n          transform: translate(-50%, -50%);\n          width: 16px;\n          height: 16px;\n          border-radius: 50%;\n          background-color: var(--color);\n          animation: dot-keys var(--animation);\n        }\n\n        .outline {\n          position: absolute;\n          transform: translate(-50%, -50%);\n          width: 20px;\n          height: 20px;\n          border-radius: 50%;\n          animation: outline-keys var(--animation);\n        }\n\n        &:nth-child(1) {\n          .outline {\n            animation-delay: 0.9s;\n          }\n        }\n\n        &:nth-child(2) {\n          animation-delay: 0.3s;\n\n          .dot {\n            animation-delay: 0.3s;\n          }\n\n          .outline {\n            animation-delay: 1.2s;\n          }\n        }\n\n        &:nth-child(3) {\n          animation-delay: 0.6s;\n\n          .dot {\n            animation-delay: 0.6s;\n          }\n\n          .outline {\n            animation-delay: 1.5s;\n          }\n        }\n\n        &:nth-child(4) {\n          animation-delay: 0.9s;\n\n          .dot {\n            animation-delay: 0.9s;\n          }\n\n          .outline {\n            animation-delay: 1.8s;\n          }\n        }\n\n        &:nth-child(5) {\n          animation-delay: 1.2s;\n\n          .dot {\n            animation-delay: 1.2s;\n          }\n\n          .outline {\n            animation-delay: 2.1s;\n          }\n        }\n      }\n    }\n  }\n}\n\n@keyframes circle-keys {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  50% {\n    transform: scale(1.5);\n    opacity: 0.5;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes dot-keys {\n  0% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes outline-keys {\n  0% {\n    transform: scale(0);\n    outline: solid 20px var(--color);\n    outline-offset: 0;\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(1);\n    outline: solid 0 transparent;\n    outline-offset: 20px;\n    opacity: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
